module.exports = (__webpack_public_path__ || '') + "static/images/mstile-150x150-9e81e1d5dc7241ac5eacb2e9179e95c0.png";